import '../LandingPage.css';
import aboutImage from '../../assets/about-tech.jpg';
import { FaCheckCircle } from 'react-icons/fa';

const highlights = [
  'Two decades of hands-on engineering experience',
  'Proven delivery across healthcare, finance & e-commerce',
  'Modern, maintainable and scalable architectures',
  'A partnership-first approach to every project',
];

function AboutSection() {
  return (
    <section id="about" className="about-section section">
      <div className="section-content">
        <div className="about-grid">
          <div className="about-image reveal">
            <img
              src={aboutImage}
              alt="Software development and technology"
              className="tech-image"
              loading="lazy"
            />
            <div className="about-image-badge">
              <span className="about-image-badge-value">20+</span>
              <span className="about-image-badge-label">years of craft</span>
            </div>
          </div>

          <div className="about-text reveal reveal-delay-1">
            <span className="section-eyebrow">About EFSoft</span>
            <h2 className="section-title">
              A software partner you can build the future with
            </h2>
            <p>
              We are a software engineering company with over 20 years of
              experience developing web applications using a wide range of
              technologies. We have delivered projects across many industries —
              including healthcare, finance and e-commerce.
            </p>
            <ul className="about-list">
              {highlights.map((item) => (
                <li key={item}>
                  <FaCheckCircle className="about-list-icon" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
